module.exports = __webpack_public_path__ + "img/paris_illu.0e1007fa.png";